// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum StateMapDisk {
  Cloud = 1,
  LocalStorage = 2,
  IndexedDB = 3,
  Memory = 4,
  Export = 5,
  Workspace = 6
}
